import OrganisationMembersAvatarGroup from './OrganisationMembersAvatarGroup';

export default OrganisationMembersAvatarGroup;